import React, { createElement } from "react";
import Storyblok, { version } from "@/lib/storyblok-client";
import { relationsToResolve } from "@/constants/general";
import { getCurrentPaths } from "@/lib/storyblok-gapi";
import Components from "../../components/components";
import { getSeoFromStory } from "@/lib/seo";
import { useStoryblok } from "../../helpers/storyblok-hook";
import { isProduction } from "../../helpers/environment";
import { Story } from "@/types/storyblok";
import { GetStaticPropsContext } from "next";

interface Props {
  story?: Story;
}

export default function Event({ story }: Props) {
  story = useStoryblok(story, !isProduction);

  return (
    story &&
    createElement(Components(story?.content?.component), {
      key: story?.uuid,
      content: story?.content,
      published: story.published_at,
      id: story?.id,
      name: story?.name,
    })
  );
}

export async function getStaticPaths() {
  const {
    EventItems: { items },
  } = await getCurrentPaths({ name: "EventItems" });

  const paths = items.map((item) => ({ params: { slug: item.slug } }));

  return {
    paths,
    fallback: "blocking",
  };
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const { params: { slug } = { slug: "" } } = context;

  try {
    const {
      data: { story },
    } = await Storyblok.get(`cdn/stories/events/${slug}`, {
      resolve_relations: relationsToResolve,
      version,
    });

    return {
      props: {
        story,
        seo: await getSeoFromStory({ story }),
        revalidate: 86400,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}
